/**
 * ## Config for main App
 *
 * @module src/config
 */

"use strict";

const func = require("../controllers/func");

const generate_series = (step) => {
  const times = []; // time array
  let tt = 0; // start time
  const ap = ["a", "p"]; // AM-PM

  for (let i = 0; tt < 24 * 60; i++) {
    const hh = Math.floor(tt / 60);
    const mm = tt % 60;
    const min = `0${mm}`.slice(-2);
    const hour = `0${hh % 12}`.slice(-2);
    times[i] = `${hour}:${min}${ap[Math.floor(hh / 12)]}`;
    tt = tt + step;
  }
  return times;
};

const vars = {
  GA_KEY: "UA-115772848-1",
  SOCKET_PORT: 443,
  API_ROOT: "https://guestlist.heartland.us/api",
};

const init = () => {
  vars.NODE_ENV = process.env.NODE_ENV || "production";

  switch (vars.NODE_ENV) {
    case "development": {
      vars.APP_ROOT = "/";
      vars.API_ROOT = "http://localhost:8080/api";
      vars.SOCKET_HOST = "http://localhost";
      vars.SOCKET_PORT = 8080;
      break;
    }
    case "production": {
      vars.APP_ROOT = "/";
      vars.SOCKET_HOST = "https://guestlist.heartland.us";
      break;
    }
    case "android": {
      vars.APP_ROOT = "https://guestlist.heartland.us/";
      vars.SOCKET_HOST = "https://guestlist.heartland.us";
      break;
    }
    case "ios": {
      vars.APP_ROOT = "https://guestlist.heartland.us/";
      vars.SOCKET_HOST = "https://guestlist.heartland.us";
      $("#layout_main").css("padding-top", "20px");
      $("#layout_chart_header_shadow").css("top", "70px");
      $("#layout_chart_rooms").css("top", "70px");
      $("#layout_chart_rooms_shadow").css("top", "120px");
      $("#layout_sidebar_shadow").css("top", "70px");
      $("#layout_sidebar_header_shadow").css("top", "70px");
      break;
    }
    default: {
      break;
    }
  }

  vars.VERSION = "4.1.2";

  vars.interfaceSpeed = 0.5;
  if (func.isMobile()) {
    vars.interfaceSpeed = 0;
  }

  vars.month = [];
  vars.month[0] = "January";
  vars.month[1] = "February";
  vars.month[2] = "March";
  vars.month[3] = "April";
  vars.month[4] = "May";
  vars.month[5] = "June";
  vars.month[6] = "July";
  vars.month[7] = "August";
  vars.month[8] = "September";
  vars.month[9] = "October";
  vars.month[10] = "November";
  vars.month[11] = "December";

  vars.day = [];
  vars.day[0] = "Sun";
  vars.day[1] = "Mon";
  vars.day[2] = "Tue";
  vars.day[3] = "Wed";
  vars.day[4] = "Thu";
  vars.day[5] = "Fri";
  vars.day[6] = "Sat";

  vars.dayfull = [];
  vars.dayfull[0] = "Sunday";
  vars.dayfull[1] = "Monday";
  vars.dayfull[2] = "Tuesday";
  vars.dayfull[3] = "Wednesday";
  vars.dayfull[4] = "Thursday";
  vars.dayfull[5] = "Friday";
  vars.dayfull[6] = "Saturday";

  vars.languages = [
    {
      description: "English",
      value: "en",
    },
    {
      description: "French",
      value: "fr-QC",
    },
  ];

  vars.time = generate_series(15);

  vars.tables = {
    rectangle: {
      seats: [1, 2, 4, 6, 8, 10, 12],
    },
    booth: {
      seats: [4, 6, 8],
    },
    combo: {
      seats: [2, 4, 6, 8],
    },
    round: {
      seats: [4, 5, 6, 8, 12],
    },
    edge: {
      seats: [2, 4],
    },
    icon: {
      // 7, 8, and 9 are for backwards compatibility to Freshtxt imports
      seats: [1, 2, 3, 4, 5, 6, 8, 10, 11, 12, 13],
    },
  };

  vars.sections = [
    {
      color: "#FFFFFF",
    },
    {
      color: "#0074D9",
    },
    {
      color: "#FF4136",
    },
    {
      color: "#5245C0",
    },
    {
      color: "#F012BE",
    },
    {
      color: "#25e8c9",
    },
    {
      color: "#57ad34",
    },
    {
      color: "#aa005b",
    },
    {
      color: "#F3EC1A",
    },
    {
      color: "#FAA41A",
    },
    {
      color: "#FFA9D5",
    },
    {
      color: "#9999FF",
    },
    {
      color: "#AAE1D7",
    },
    {
      color: "#D4FFA2",
    },
    {
      color: "#FFCF70",
    },
    {
      color: "#c90004",
    },
    {
      color: "#560077",
    },
    {
      color: "#274974",
    },
    {
      color: "#a6af00",
    },
    {
      color: "#6d4900",
    },
    {
      color: "#C45800",
    },
    {
      color: "#416359",
    },
    {
      color: "#591511",
    },
    {
      color: "#b685e5",
    },
    {
      color: "#797979",
    },
    //
    {
      color: "#0074D9",
      color2: "#BFCE37",
    },
    {
      color: "#FF4136",
      color2: "#F3EC1A",
    },
    {
      color: "#5245C0",
      color2: "#FFA9D5",
    },
    {
      color: "#4177BC",
      color2: "#9999FF",
    },
    {
      color: "#41BBA4",
      color2: "#AAE1D7",
    },
    {
      color: "#65C53D",
      color2: "#D4FFA2",
    },
    {
      color: "#BFCE37",
      color2: "#FFCF70",
    },
    {
      color: "#F3EC1A",
      color2: "#8F0C0F",
    },
    {
      color: "#FAA41A",
      color2: "#560077",
    },
    {
      color: "#FFA9D5",
      color2: "#274974",
    },
    {
      color: "#9999FF",
      color2: "#696F00",
    },
    {
      color: "#AAE1D7",
      color2: "#976900",
    },
    {
      color: "#D4FFA2",
      color2: "#C45800",
    },
    {
      color: "#FFCF70",
      color2: "#416359",
    },
    {
      color: "#8F0C0F",
      color2: "#634341",
    },
    {
      color: "#560077",
      color2: "#524163",
    },
    {
      color: "#274974",
      color2: "#797979",
    },
    {
      color: "#696F00",
      color2: "#D139AB",
    },
    {
      color: "#976900",
      color2: "#943F98",
    },
    {
      color: "#C45800",
      color2: "#5245C0",
    },
    {
      color: "#416359",
      color2: "#4177BC",
    },
    {
      color: "#634341",
      color2: "#65C53D",
    },
    {
      color: "#524163",
      color2: "#BFCE37",
    },
    {
      color: "#797979",
      color2: "#BFCE37",
    },
  ];

  vars.turnTimes = [
    {
      description: "10min",
      value: 10,
    },
    {
      description: "15min",
      value: 15,
    },
    {
      description: "20min",
      value: 20,
    },
    {
      description: "25min",
      value: 25,
    },
    {
      description: "30min",
      value: 30,
    },
    {
      description: "35min",
      value: 35,
    },
    {
      description: "40min",
      value: 40,
    },
    {
      description: "45min",
      value: 45,
    },
    {
      description: "50min",
      value: 50,
    },
    {
      description: "55min",
      value: 55,
    },
    {
      description: "1hr",
      value: 60,
    },
    {
      description: "1hr 5min",
      value: 65,
    },
    {
      description: "1hr 10min",
      value: 70,
    },
    {
      description: "1hr 15min",
      value: 75,
    },
    {
      description: "1hr 30min",
      value: 90,
    },
    {
      description: "1hr 45min",
      value: 105,
    },
    {
      description: "2hr",
      value: 120,
    },
    {
      description: "2hr 30min",
      value: 150,
    },
    {
      description: "3hr",
      value: 180,
    },
  ];

  vars.basicTableStatus = [
    {
      description: "Disabled",
      value: 1,
    },
  ];

  vars.alertTypes = [
    {
      description: "Text Message",
      value: 1,
    },
    {
      description: "Automated Phone Call",
      value: 2,
    },
    {
      description: "Coaster Pager",
      value: 3,
    },
    {
      description: "Email",
      value: 4,
    },
    {
      description: "Guest Waiting",
      value: 5,
    },
  ];

  vars.filterTypes = [
    {
      description: "Show All",
      value: 1,
    },
    {
      description: "Over Call Back Time",
      value: 2,
    },
    {
      description: "Within 5 Minutes and Over",
      value: 3,
    },
    {
      description: "Alerted Parties",
      value: 4,
    },
  ];

  vars.partySizes = [
    {
      description: "1 person",
      value: 1,
    },
    {
      description: "2 people",
      value: 2,
    },
    {
      description: "3 people",
      value: 3,
    },
    {
      description: "4 people",
      value: 4,
    },
    {
      description: "5 people",
      value: 5,
    },
    {
      description: "6 people",
      value: 6,
    },
    {
      description: "7 people",
      value: 7,
    },
    {
      description: "8 people",
      value: 8,
    },
    {
      description: "9 people",
      value: 9,
    },
    {
      description: "10 people",
      value: 10,
    },
    {
      description: "11 people",
      value: 11,
    },
    {
      description: "12 people",
      value: 12,
    },
    {
      description: "13 people",
      value: 13,
    },
    {
      description: "14 people",
      value: 14,
    },
    {
      description: "15 people",
      value: 15,
    },
    {
      description: "16 people",
      value: 16,
    },
    {
      description: "17 people",
      value: 17,
    },
    {
      description: "18 people",
      value: 18,
    },
    {
      description: "19 people",
      value: 19,
    },
    {
      description: "20 people",
      value: 20,
    },
    {
      description: "21 people",
      value: 21,
    },
    {
      description: "22 people",
      value: 22,
    },
    {
      description: "23 people",
      value: 23,
    },
    {
      description: "24 people",
      value: 24,
    },
    {
      description: "25 people",
      value: 25,
    },
    {
      description: "30 people",
      value: 30,
    },
    {
      description: "35 people",
      value: 35,
    },
    {
      description: "40 people",
      value: 40,
    },
    {
      description: "45 people",
      value: 45,
    },
    {
      description: "50 people",
      value: 50,
    },
  ];

  vars.quoteTimes = [
    {
      description: "2-5 minutes",
      value: 2,
    },
    {
      description: "5-10 minutes",
      value: 5,
    },
    {
      description: "10-15 minutes",
      value: 10,
    },
    {
      description: "15-20 minutes",
      value: 15,
    },
    {
      description: "20-25 minutes",
      value: 20,
    },
    {
      description: "25-30 minutes",
      value: 25,
    },
    {
      description: "30-35 minutes",
      value: 30,
    },
    {
      description: "35-40 minutes",
      value: 35,
    },
    {
      description: "40-45 minutes",
      value: 40,
    },
    {
      description: "45-50 minutes",
      value: 45,
    },
    {
      description: "50-55 minutes",
      value: 50,
    },
    {
      description: "55-60 minutes",
      value: 55,
    },
    {
      description: "60-70 minutes",
      value: 60,
    },
    {
      description: "70-80 minutes",
      value: 70,
    },
    {
      description: "1 hour 30 minutes",
      value: 90,
    },
    {
      description: "1 hour 45 minutes",
      value: 105,
    },
    {
      description: "2 hours",
      value: 120,
    },
    {
      description: "2 hours 30 minutes",
      value: 150,
    },
    {
      description: "3 hours",
      value: 180,
    },
  ];

  vars.config = {
    location: {},
    chart: {},
    limit: {},
    template: [],
  };
};

/** Domain collections to be transferred to the socket clients  */

const domains = [
  "activity",
  "location",
  "limit",
  "reservation",
  "template",
  "chart",
  "note",
];

module.exports = {
  init,
  vars,
  domains,
};



/** WEBPACK FOOTER **
 ** ./src/config/index.js
 **/